import {
  actionTypes,
  typeRequestFailure,
  typeRequestSuccess,
  fieldRequestFailure,
  fieldRequestSuccess,
  sendRequestFailure,
  sendRequestSuccess,
  getServiceRequestBAOFailure,
  getServiceRequestBAOSuccess,
  getServiceRequestApplicationsFailure,
  getServiceRequestApplicationsSuccess,
  sendNewApiRequestSuccess,
  sendNewApiRequestFailure,
} from "./actions";
import {
  fetchTypeRequest,
  fetchFieldRequest,
  sendServiceRequest,
  fetchBAORequest,
  fetchApplicationsRequest,
  sendNewApiServiceRequest,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchTypeRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TYPE_REQUEST),
    mergeMap((action: any) =>
      fetchTypeRequest().pipe(
        map((response: any) => typeRequestSuccess(response)),
        catchError((error: any) => of(typeRequestFailure(error)))
      )
    )
  );

const fetchFieldRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FIELD_REQUEST),
    mergeMap((action: any) =>
      fetchFieldRequest(action.idServiceRequest).pipe(
        map((response: any) => fieldRequestSuccess(response)),
        catchError((error: any) => of(fieldRequestFailure(error)))
      )
    )
  );

const sendServiceRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SEND_REQUEST),
    mergeMap((action: any) =>
      sendServiceRequest(action.obj).pipe(
        map(() => sendRequestSuccess()),
        catchError((error: any) => of(sendRequestFailure(error)))
      )
    )
  );

const sendNewApiServiceRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SEND_NEW_API_REQUEST),
    mergeMap((action: any) =>
      sendNewApiServiceRequest(action.obj).pipe(
        map(() => sendNewApiRequestSuccess()),
        catchError((error: any) => of(sendNewApiRequestFailure(error)))
      )
    )
  );

const fetchBAORequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SERVICE_RERQUEST_BAO),
    mergeMap((action: any) =>
      fetchBAORequest().pipe(
        map((response: any) => getServiceRequestBAOSuccess(response)),
        catchError((error: any) => of(getServiceRequestBAOFailure(error)))
      )
    )
  );

const fetchApplicationsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS),
    mergeMap((action: any) =>
      fetchApplicationsRequest().pipe(
        map((response: any) => getServiceRequestApplicationsSuccess(response)),
        catchError((error: any) =>
          of(getServiceRequestApplicationsFailure(error))
        )
      )
    )
  );

export default [
  fetchTypeRequestEpic,
  fetchFieldRequestEpic,
  sendServiceRequestEpic,
  fetchBAORequestEpic,
  fetchApplicationsRequestEpic,
  sendNewApiServiceRequestEpic,
];
